export * from './treatment-reviewer.component';
